import React from 'react';
import { useTheme } from 'styled-components/macro';
import { Plus } from '@profitfy/pakkun-icons';
import { ETextSize, ETextWeight } from '@domain/enums/components/EText';

import { INewStoreProps } from '@domain/interfaces/stores/INewStore';

import * as S from './styles';

const NewStore: React.FC<INewStoreProps> = ({ toggle }) => {
  const theme: any = useTheme();

  return (
    <S.Button onClick={toggle}>
      <S.Card>
        <S.Text size={ETextSize.B3} weight={ETextWeight.MEDIUM}>
          Cadastrar nova loja
        </S.Text>

        <Plus size={24} color={theme.colors.font} />
      </S.Card>
    </S.Button>
  );
};

export default NewStore;
